import styled from "styled-components";

export const ControllerHeaderInfoWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const ControllerHeaderInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  color: #fff;
  flex: 0.25;
  height: 212px;
  border-radius: 20px;
  box-shadow: 10px 10px 10px 0px #0000004d;
  background: #2e2e2e;
  padding: 0 30px;
  font-family: Pretendard;
  box-sizing: border-box;

  > .title {
    font-weight: 500;
    font-size: 30px;
  }

  > .value {
    font-weight: 600;
    font-size: 70px;
  }
`;

export const ControllerHeaderInfoEdit = styled.div<{ isInput: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .button {
    cursor: pointer;
    background: ${(p) => (p.isInput ? "#3052FB" : "#969696")};
    width: 132px;
    height: 70px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 25px;
    line-height: 70px;
    text-align: center;
  }
`;

export const ControllerHeaderInfoInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  height: 84px;

  > .box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px;
    border: 1px solid transparent;
    border-radius: 20px;
    background-image: linear-gradient(#424242ff, #424242ff),
      linear-gradient(180deg, #fff 0%, #0000000d 80%);
    background-origin: border-box;
    background-clip: content-box, border-box;

    > input {
      width: 104px;
      height: 70px;
      border: none;
      outline: none;
      font-family: Pretendard;
      font-weight: 600;
      font-size: 50px;
      line-height: 70px;
      text-align: center;
      color: #fff;
      background: #0000000d;
      border-radius: 20px;
    }
  }
`;
